module.exports = "https://static.im-cdn.com/mjc/storefront/Florencia/static/media/ArrowDown.b519b45d.svg";